<template>
    <!-- Usamos o componente de transição do Vue -->
    <transition name="fade">
      <div v-if="showModal" class="feedback-modal">
        <div class="feedback-modal-backdrop" @click="closeModal"></div>
        <div class="feedback-modal-dialog">
          <div class="feedback-modal-content">
            <div class="feedback-modal-header">
              <h5 class="modal-title">Enviar feedback de {{ requirementDesc }}</h5>
              <button type="button" class="close" @click="closeModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="feedback-modal-body">
              <div class="feedback-text-container">
                <span>Digite o texto a ser enviado ao cliente</span>
                <textarea class="form-control" rows="13" v-model="feedback"></textarea>
                <div class="alert alert-primary obs-span">
                  Para negrito, envolva a palavra em asteriscos <strong>( * )</strong>.   Exemplo: *palavra* <br/>
                  Para itálico, envolva a palavra em underlines <strong>( _ )</strong>.   Exemplo: _palavra_ <br/>
                  Para sublinhado, envolva a palavra em til <strong>( ~ )</strong>.   Exemplo: ~palavra~ <br/>
                  <strong>Obs: </strong> Não adicione espaços entre os caracteres especiais e a palavra.
                </div>
              </div>
              <div class="feedback-preview">
                <div class="feedback-preview__header">
                  <span>Preview da mensagem</span>
                </div>
                <div class="preview-slot">
                  <div class="message-item">
                    <div class="message-body">
                        <span class="body-preview-text">{{ msgPreview }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="feedback-modal-footer">
              <button class="cancel-button" @click="closeModal">
                <i class="fas fa-times"></i>   
                Cancelar
              </button>
              <button class="send-button" @click="sendMessage">
                <i class="fas fa-paper-plane"></i>   
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import {mapActions} from 'vuex';
  export default {
    props: ['showModal', 'requirementInfo'],
    data() {
      return {
        requirementDesc: '',
        intro: '',
        feedback: '',
        disclaimer: `_Essa mensagem é apenas para fins informativos. Mas não se preocupe, se ainda precisar de ajuda, basta nos acionar novamente e falar com um de nossos atendentes._`
      };
    },
    computed: {
      msgPreview(){
        return `${this.intro}

${this.feedback}

${this.disclaimer}` 
      }
    },
    methods: {
      ...mapActions([
        "sendFeedbackMessage",
      ]),
      closeModal(mode = 'default') {
        this.$emit('closeFeedbackModal', mode)
    },
      async sendMessage(){
        if(!this.feedback){
          Swal.fire({
            type: 'error',
            html: '<strong>Digite uma mensagem para enviar ao cliente!</strong>'
          });
          return
        }
        let loading;
        try {
          const obj = {
            client_id: this.requirementInfo.id.split('_')[0],
            message: this.msgPreview,
            requirement_id: this.requirementInfo.id,
            protocol: this.requirementInfo.protocolo
          }
          loading = Swal.fire({
				    text: "Enviando feedback. Por favor, aguarde...",
				    showConfirmButton: false,
				    html: `<div><i class="fas fa-spinner fa-pulse"></i><br><span><b>Enviando feedback</b> <br>Por favor, aguarde...</span></div>`,
            allowOutsideClick: false
			    });
          const response = await this.sendFeedbackMessage(obj)
          if(response && response.status === 'success'){
            Swal.fire({
				      title: "Sucesso!",
				      html: response.message,
				      type: 'success',
				      confirmButtonText: "Ok"
			      }).then(() => {
              if(loading) loading.close()
              this.closeModal('saving')
            });
          } else if(!response || response.status === 'fail') {
            Swal.fire({
				      title: "Erro!",
				      html: response.message || 'Erro ao enviar feedback',
				      type: 'error',
				      confirmButtonText: "Ok"
			      }).then(() => {
              if(loading) loading.close()
              this.closeModal()
            });
          } else {
            Swal.fire({
				      title: "Erro!",
				      html: '<span>Ocorreu um erro ao salvar o feedback</span>',
				      type: 'error',
				      confirmButtonText: "Ok"
			      }).then(() => {
              if(loading) loading.close()
              this.closeModal()
          });
        }
        
      } catch (error) {
        console.error('Erro ao enviar mensagem: ', error)
        if(loading) loading.close()
          this.closeModal()
        }
      }
    },
    mounted(){
      if(Object.keys(this.requirementInfo).length){
        this.requirementDesc = 'solicitação'
        this.intro = `Olá! Esta é uma mensagem automática da *Tecban* sobre sua solicitação aberta em nosso sistema.`
      }
    },
  };
  </script>
  
  <style scoped lang="scss">
  .feedback-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
  }
  
  .feedback-modal-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
  }
  
  .feedback-modal-dialog {
    position: relative;
    z-index: 1051;
    background: white;
    border-radius: 0.3rem;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    width: 70vw;
    height: 60vh;
    max-height: 60vh;
    max-width: 100%;
    overflow: hidden;
  }

  .feedback-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .feedback-modal-header,
  .feedback-modal-footer {
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
    font-weight: bold;
    display: flex;
    gap: 10px;

    button {
      border-radius: 7px !important;
      transition: 0.3s ease-in-out;
      border: none;
      padding: 5px 10px;
    }
    .send-button {
      background-color: rgb(46, 134, 46);
      color: white;

      &:hover {
        background-color: rgb(33, 95, 33);
      }
    }

    .cancel-button {
      background-color: rgb(179, 52, 52);
      color: white;

      &:hover {
        background-color: rgb(141, 42, 42);
      }
    }
  }
  
  .feedback-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .modal-title {
      font-weight: bold;
    }
  }
  
  .feedback-modal-body {
    padding: 1rem;
    display: flex;
    gap: 10px;
    max-height: 100%;
    overflow: hidden;
  }

  .feedback-text-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 7px;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;

    textarea {
      resize: none
    }

    span {
      font-size: medium;
      font-weight: bold;
    }

    .obs-span {
      font-size: x-small;
      margin: 3px;
      padding: 3px;
    }
  }

  .feedback-preview {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 7px;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;
    min-width: 0;

    &__header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        padding: 10px;

        button {
            border-radius: 10px !important;
        }
    }

    .preview-slot {
      background-image: url('/images/background-wpp.png');
      background-color: #263b47;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      height: 100%;
      width: 100%;
      border-radius: 10px;
      overflow-y: auto;

      .message-item {
        background-color: #037963;
        color: white;
        border-radius: 10px;
        margin: 10px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .message-body {
          font-size: 12px;
          font-weight: 500;

          .body-preview-text {
              white-space: pre-line;
              word-wrap: break-word;
              overflow-wrap: break-word;
              word-break: break-word;
              width: 100%;
          }
        }
      }
    }
  }
  
  .feedback-modal-footer {
    display: flex;
    justify-content: flex-end;
  }
  
  .close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores ao Vue 2.1.8 */ {
    opacity: 0;
  }
  </style>